import { Lock } from 'lucide-react';

/**
 * The left column shared by the login + register split layouts: what Lizrd is
 * really for — full transparency into cost and real, deep optimization guidance —
 * plus a calm security note. Visual, on-brand, and theme-aware.
 */
const VALUE = [
  {
    icon: 'transparency' as const,
    title: 'Full transparency into cost',
    body: 'See exactly where every dollar goes across your clouds — and understand why it goes there.',
  },
  {
    icon: 'guidance' as const,
    title: 'Real, deep optimization guidance',
    body: 'The exact fix for each opportunity — tailored code, step by step, quick and low-risk.',
  },
];

function Icon({ name }: { name: (typeof VALUE)[number]['icon'] }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {name === 'transparency' && (
        <>
          <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
          <circle cx="12" cy="12" r="3" />
        </>
      )}
      {name === 'guidance' && (
        <>
          <path d="m14.7 6.3-8.4 8.4a2 2 0 1 0 3 3l8.4-8.4a4 4 0 1 1-3-3Z" />
          <path d="m9 15 1 1" />
        </>
      )}
    </svg>
  );
}

export function AuthValueRail() {
  return (
    <div className="flex flex-1 flex-col justify-center gap-8">
      <ul className="space-y-6">
        {VALUE.map((v) => (
          <li key={v.title} className="flex items-center gap-4">
            <span className="flex-none text-iris">
              <Icon name={v.icon} />
            </span>
            <div>
              <p className="font-display text-base font-bold text-bone">{v.title}</p>
              <p className="mt-1 text-sm leading-relaxed text-muted">{v.body}</p>
            </div>
          </li>
        ))}
      </ul>
      <div className="flex items-start gap-2 rounded-lg border border-hairline bg-surface p-3 text-xs leading-relaxed text-muted">
        <Lock aria-hidden className="mt-0.5 h-4 w-4 flex-none text-iris" />
        <span>
          <span className="font-semibold text-bone">Secure by design.</span> Read-only and encrypted
          — Lizrd reads only your infrastructure data, never changes anything, and never touches
          your customers' data.
        </span>
      </div>
    </div>
  );
}
